var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVariant3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Header/Variant3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.3281 13.7453C16.8945 12.9984 16.25 10.8852 16.25 8.125C16.25 6.4674 15.5915 4.87769 14.4194 3.70558C13.2473 2.53348 11.6576 1.875 10 1.875C8.3424 1.875 6.75269 2.53348 5.58058 3.70558C4.40848 4.87769 3.75 6.4674 3.75 8.125C3.75 10.8859 3.10469 12.9984 2.67109 13.7453C2.56037 13.9352 2.50167 14.1509 2.50091 14.3707C2.50016 14.5905 2.55738 14.8066 2.6668 14.9973C2.77622 15.1879 2.93397 15.3463 3.12415 15.4565C3.31432 15.5667 3.5302 15.6248 3.75 15.625H6.93828C7.08248 16.3306 7.46596 16.9647 8.02385 17.4201C8.58175 17.8756 9.27983 18.1243 10 18.1243C10.7202 18.1243 11.4182 17.8756 11.9761 17.4201C12.534 16.9647 12.9175 16.3306 13.0617 15.625H16.25C16.4697 15.6247 16.6855 15.5665 16.8756 15.4562C17.0656 15.346 17.2233 15.1875 17.3326 14.9969C17.4419 14.8063 17.4991 14.5903 17.4983 14.3705C17.4975 14.1508 17.4388 13.9351 17.3281 13.7453ZM10 16.875C9.61236 16.8749 9.23428 16.7546 8.91781 16.5308C8.60134 16.3069 8.36203 15.9905 8.23281 15.625H11.7672C11.638 15.9905 11.3987 16.3069 11.0822 16.5308C10.7657 16.7546 10.3876 16.8749 10 16.875ZM3.75 14.375C4.35156 13.3406 5 10.9438 5 8.125C5 6.79892 5.52678 5.52715 6.46447 4.58947C7.40215 3.65178 8.67392 3.125 10 3.125C11.3261 3.125 12.5979 3.65178 13.5355 4.58947C14.4732 5.52715 15 6.79892 15 8.125C15 10.9414 15.6469 13.3383 16.25 14.375H3.75Z",
    fill: "#026735"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 159",
    cx: 14.375,
    cy: 4.375,
    r: 3.125,
    fill: "#E33B32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariant3);
export default __webpack_public_path__ + "static/media/Variant3.52a75872d6ef60b934c73e62a2448c3d.svg";
export { ForwardRef as ReactComponent };